import { Component, Injector } from '@angular/core';
import { addIcons } from 'ionicons';
import {
  arrowBackOutline,
  callOutline,
  caretDownOutline,
  checkmark,
  chevronForwardOutline,
  close,
  cogOutline,
  eyeOffOutline,
  eyeOutline,
  languageOutline,
  logOutOutline,
  mailOutline,
  personRemoveOutline,
  settingsOutline,
  storefrontOutline,
  timerOutline,
} from 'ionicons/icons';
import { ThemeService } from './appServices/theme.service';
import { GlobalAuthResolver } from './appServices/global-auth/global-auth.resolver';
import { StoreResolver } from './appServices/store/store.resolver';
import { TranslationService } from './appServices/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    public themeService: ThemeService,
    private _storeResolver: StoreResolver,
    private _globalAuthResolver: GlobalAuthResolver,
    private injector: Injector
  ) {
    addIcons({
      'arrow-back-outline': arrowBackOutline,
      'call-outline': callOutline,
      'caret-down-outline': caretDownOutline,
      checkmark,
      'chevron-forward-outline': chevronForwardOutline,
      close,
      'cog-outline': cogOutline,
      'eye-off-outline': eyeOffOutline,
      'eye-outline': eyeOutline,
      'language-outline': languageOutline,
      'log-out-outline': logOutOutline,
      'mail-outline': mailOutline,
      'person-remove-outline': personRemoveOutline,
      'settings-outline': settingsOutline,
      'storefront-outline': storefrontOutline,
      'timer-outline': timerOutline,
    });
    this.initializeApp();
  }

  async initializeApp() {
    // Wait for translation service to initialize first (loads language from localStorage)
    const translationService = this.injector.get(TranslationService);
    await translationService.waitForInitialization();

    // Verify translations are actually loaded
    if (!translationService.areTranslationsLoaded()) {
      console.warn(
        'Translations not loaded after initialization wait - this may cause translation keys to display',
      );
    }

    this.checkLogin();
  }

  initBasicInfo() {
    this._storeResolver.setupStore(true);
    this._globalAuthResolver.getProfile();
  }

  checkLogin() {
    const token = localStorage.getItem('token');
    if (token) {
      this._globalAuthResolver.loggedIn.next(true);
      this.initBasicInfo();
    }
  }
}
